import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';
import { StatusPicker } from '../TaskDialog/StatusPicker';

interface AddStatusButtonProps {
  boardId: string;
}

export function AddStatusButton({ boardId }: AddStatusButtonProps) {
  const { t } = useTranslation('tasks');

  return (
    <StatusPicker
      boardId={boardId}
      trigger={
        <Button
          variant="ghost"
          size="sm"
          className="shrink-0 gap-1.5 text-muted-foreground"
          data-testid="tasks-add-status-button"
        >
          <Plus className="size-3.5" />
          {t('boardView.addStatus')}
        </Button>
      }
    />
  );
}
